export const KYC_STATUS = {
    COMPLETED: 'COMPLETED',
    NEEDS_REVIEW: 'NEEDS_REVIEW',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED',
    DECLINED: 'DECLINED',
} as const;

export type KycStatus = typeof KYC_STATUS[keyof typeof KYC_STATUS]; 